<template>
  <div>
    <CRow class="w-100">
      <!-- {{ $store.getters.get_company }} -->
      <CCol md="12" lg="12" sm="12" xs="12">
        <ProccessVueKatalynas v-if="page == 'proccess'  && $store.getters.get_company.id == 10 && $store.getters.get_rol.id == 2" @changePage="changePage" @setView="setView" />
        <ProccessVue  v-else-if="page == 'proccess' " @changePage="changePage" @setView="setView" />
        
        <PurchaseIseaVue class="pt-1" v-if="page == 'purchase' && $store.getters.get_company.id == 11 && $store.getters.get_rol.id == 4" @returnHome="returnHome" />
        <PurchaseVue class="pt-1"  v-else-if="page == 'purchase'" @returnHome="returnHome" />
        
        <SaleVue class="pt-1" v-if="page == 'sale'" @returnHome="returnHome" />
        
        <StockIseaVue class="pt-1" v-if="page == 'stock' && $store.getters.get_company.id == 11 && $store.getters.get_rol.id == 4" @returnHome="returnHome" />
        <StockVue class="pt-1" v-else-if="page == 'stock'" @returnHome="returnHome" />
        <!-- <KardexVue class="pt-1" v-if="hasRoles([2,4]) && page=='kardex'" @returnHome="returnHome"/> -->
        <SendBithadyVue class="pt-1" v-if="page == 'sendbirthay'" @returnHome="returnHome" />
        <SendPromotionVue class="pt-1" v-if="page == 'promotion'" @returnHome="returnHome" />

        <SessionDemo class="pt-1" v-if="page == 'session'" @returnHome="returnHome"  />
        <Remuneration class="pt-1" v-if="page == 'remuneration'" @returnHome="returnHome"  />

      </CCol>
    </CRow>
  </div>
</template>

<script>

import ProccessVueKatalynas from '../../components/proccess/Katalynas/Recepcionistas/Home.vue';
import ProccessVue from '../../components/proccess/Home.vue';
import SendBithadyVue from '../../components/proccess/Katalynas/pages/SendBithady.vue';
import SendPromotionVue from '../../components/proccess/Katalynas/pages/SendPromotion.vue';

import PurchaseIseaVue from '../../components/proccess/Isea/Purchase.vue';
import PurchaseVue from '../../components/proccess/purchase/page/Purchase.vue';

import SaleVue from '../../components/proccess/sale/page/Sale.vue';

import StockVue from '../../components/proccess/stock/page/Stock.vue';
import StockIseaVue from '../../components/proccess/Isea/Stock.vue';
// import KardexVue from '../../components/proccess/kardex/page/Kardex.vue';
import SessionDemo from '../../components/proccess/Session/demo.vue';
import Remuneration from '../../components/proccess/Katalynas/pages/Remuneration.vue';


export default {
  components: {
    PurchaseVue,
    SaleVue,
    ProccessVue,
    StockVue,
    StockIseaVue,
    // KardexVue,
    SendBithadyVue,
    SendPromotionVue,
    SessionDemo,
    Remuneration,
    ProccessVueKatalynas,
    PurchaseIseaVue
  },
  data() {
    return {
      page: 'proccess',
      // userRoles: this.$store.getters.get_roles.map(role => role.role.id)
    }
  },
  methods: {
    changePage(page) {
      this.page = page;
      this.$emit("mtdViewFooter", false, 'proccess');
    },
    returnHome() {
      this.page = 'proccess';
      this.$emit("mtdViewFooter", true, 'proccess');
    },
    hasRoles(roles) {
      return roles.some(role => this.userRoles.includes(role));
    },
    mtdBack: function () {
      this.page = 'home';
      // this.$emit('setView', 'home')
    },
    setView: function(){
      this.$emit('setView', 'home')
    }
  }
};
</script>